import { removeDiacritics } from '@mahawi/eshop-common/src/remove-diacritics';
import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import { type DefaultOptionType } from 'antd/lib/select';

export const getFilterOption = (
  inputValue: string,
  option?: DefaultOptionType,
): boolean => {
  const labelText: string = removeDiacritics(
    String(option ? option.label : '').toLowerCase(),
  );

  const inputValues: string[] = removeDiacritics(inputValue.trim())
    .toLowerCase()
    .split(' ');

  return inputValues.every((v: string): boolean => labelText.includes(v));
};

export const getFilterSort = (
  optionA?: DefaultOptionType,
  optionB?: DefaultOptionType,
): number => {
  const labelAText: string = String(optionA ? optionA.label : '').toLowerCase();

  const labelBText: string = String(optionB ? optionB.label : '').toLowerCase();

  return stringCompare(labelAText, labelBText);
};
